import { useState } from 'react';
import { PROSPECT } from '../prospect.js';
import { LandingScreen } from './LandingScreen.js';

export function LandingPage(): JSX.Element {
  const [revealed,     setRevealed    ] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [cardVisible,  setCardVisible ] = useState(false);

  const handleRevealComplete = (): void => {
    setRevealed(true);
    // Same stagger used by AuthGate's post-auth reveal path.
    window.setTimeout(() => {
      setTitleVisible(true);
      window.setTimeout(() => setCardVisible(true), 480);
    }, 50);
  };

  return (
    <>
      <LandingScreen autoReveal onRevealComplete={handleRevealComplete} />

      {/* Overlay sits above LandingScreen's fixed z-index (100). Only becomes
          interactive after the reveal animation completes so the animation
          phase doesn't capture pointer events. */}
      <div
        style={{
          position: 'fixed', inset: 0,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '2rem',
          zIndex: 101,
          pointerEvents: revealed ? 'auto' : 'none',
        }}
      >
        <div
          style={{
            fontFamily: 'var(--sans)',
            fontWeight: 300,
            fontSize: 'clamp(3.2rem, 8vw, 7rem)',
            letterSpacing: '0.04em',
            color: '#ffffff',
            userSelect: 'none',
            lineHeight: 1,
            marginBottom: '2.2rem',
            opacity: titleVisible ? 1 : 0,
            transition: 'opacity 0.8s ease',
          }}
        >
          stackbtc
        </div>

        <div
          style={{
            width: '100%',
            maxWidth: 400,
            background: 'rgba(4, 2, 10, 0.75)',
            backdropFilter: 'blur(30px)',
            WebkitBackdropFilter: 'blur(30px)',
            borderRadius: 12,
            border: '1px solid rgba(255,255,255,0.07)',
            padding: '1.75rem 2rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.1rem',
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? 'translateY(0px)' : 'translateY(18px)',
            transition: 'opacity 1.4s cubic-bezier(0.2,0.8,0.2,1), transform 1.4s cubic-bezier(0.2,0.8,0.2,1)',
          }}
        >
          <p style={{ fontSize: 'var(--fs-small)', color: 'var(--text-soft)', lineHeight: 1.65, margin: 0 }}>
            {PROSPECT.tagline}
          </p>
          <p style={{ fontSize: 'var(--fs-small)', color: 'var(--text-soft)', lineHeight: 1.65, margin: 0 }}>
            To learn more, reach out to{' '}
            <a
              href={`mailto:${PROSPECT.contactEmail}`}
              style={{ color: 'rgba(255,255,255,0.75)', textDecoration: 'underline' }}
            >
              {PROSPECT.contactEmail}
            </a>.
          </p>
        </div>
      </div>
    </>
  );
}
